import axios from 'axios'

export default {
    SENDCONTACTUSFORM ({ commit }, contactForm) {
        return axios.post('/contact', contactForm).then((response) => {
        }, (err) => {
            commit('setError', { error: {show: true, message: 'Message could not be sent'} })
            console.log('err ', err)
        })
    },
    BECOME_EXPERT_REQUEST ({ commit }, contactForm) {
        return axios.post('/experts/insertBecomeAnExpert', contactForm).then((response) => {
        }, (err) => {
            commit('setError', { error: {show: true, message: 'Request could not be sent'} })
            console.log('err ', err)
        })
    },
    SENDFEEDBACKFORM ({ commit }, feedback) {
        return axios.post('/feedback', feedback).then((response) => {
        }, (err) => {
            commit('setError', { error: {show: true, message: 'Message could not be sent'} })
            console.log('err ', err)
        })
    }
}



// WEBPACK FOOTER //
// ./src/store/contactus/actions.js